import React from "react";
import "./TestimonialStrip.scss";

/* Keeps build safe if the avatar filename differs; uses it when present */
function loadAvatar() {
  const placeholder =
    "data:image/svg+xml;utf8," +
    encodeURIComponent(
      `<svg xmlns='http://www.w3.org/2000/svg' width='73' height='73'>
         <circle cx='36.5' cy='36.5' r='36.5' fill='%23E7E7E7'/>
       </svg>`
    );

  try {
    const ctx = require.context(
      "../../../../resources/images/brandkeeper",
      false,
      /\.(png|jpe?g|webp)$/
    );
    try { return ctx("./alastair-smith-135x135.jpeg"); } catch (_) {}
    try { return ctx("./alastair-smith-135x135.jpg"); } catch (_) {}
    return placeholder;
  } catch {
    return placeholder;
  }
}

const Alastair = loadAvatar();

export default function TestimonialStrip() {
  // Build Review JSON-LD without altering visible content
  const origin =
    typeof window !== "undefined" && window.location
      ? window.location.origin
      : "https://martleystrategy.com";

  const reviewLd = {
    "@context": "https://schema.org",
    "@type": "Review",
    "name": "Client testimonial from Alastair Smith, CEO at Outdesk AU",
    "url": `${origin}/brandkeeper`,
    "author": { "@type": "Person", "name": "Alastair Smith" },
    "itemReviewed": { "@type": "Organization", "name": "Martley Strategy™" },
    "reviewBody":
      "Working with the team has significantly streamlined our design process. Projects are delivered on time, aligned with our brand, and require far less back-and-forth. It’s been a reliable, efficient partnership.",
    "publisher": { "@type": "Organization", "name": "Martley Strategy™" }
    // no rating to avoid implying numeric stars
  };

  return (
    <section className="tstrip" aria-label="Customer testimonial">
      <div className="tstrip__inner">
        <figure className="tstrip__figure">
          <blockquote className="tstrip__quote">
            <p>
              Working with the team has significantly streamlined our design
              process. Projects are delivered on time, aligned with our brand,
              and require far less back-and-forth. It’s been a reliable,
              efficient partnership.
            </p>
          </blockquote>

          <figcaption className="tstrip__meta">
            <img
              className="tstrip__avatar"
              src={Alastair}
              width={36}
              height={36}
              alt="Alastair Smith"
              loading="lazy"
            />
            <div className="tstrip__name">Alastair Smith / CEO at Outdesk AU</div>
            <div className="tstrip__eyebrow">
              Based on ad creative and web design projects with Martley Strategy™
            </div>
          </figcaption>
        </figure>
      </div>

      {/* Review JSON-LD (non-visual) */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(reviewLd) }}
      />
    </section>
  );
}